"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertTrigger = void 0;
const ModelCommon_1 = require("../ModelCommon");
const typeName = 'AlertTrigger';
class AlertTrigger extends ModelCommon_1.ModelCommon {
    constructor({ ...ob }) {
        super(ob.type || typeName, { ...ob });
    }
    get timestampOpen() {
        return this.timestamp ?? undefined;
    }
    set timestampOpen(timestamp) {
        this.timestamp = timestamp;
    }
    get alertDetail() {
        return this._alertDetail;
    }
    set alertDetail(detail) {
        this._alertDetail = detail;
    }
    get entityTriggeringAlert() {
        return this._entityTriggeringAlert;
    }
    set entityTriggeringAlert(entity) {
        this._entityTriggeringAlert = entity;
    }
    get entityTriggeringAlertName() {
        return this._entityTriggeringAlert?.name;
    }
    set entityTriggeringAlertName(name) {
        if (this._entityTriggeringAlert)
            this._entityTriggeringAlert.name = name;
    }
    get summary() {
        return this._summary;
    }
    set summary(summary) {
        this._summary = summary;
    }
    get initiator() {
        return this._initiator;
    }
    set initiator(initiator) {
        this._initiator = initiator;
    }
    get initiatorName() {
        return this._initiator?.name;
    }
    set initiatorName(noThnanks) { }
    updateDynamicKeys() {
        this.dsk = `${this.status}:${this.incidentType}:${this.incidentEntity?.sk}`;
        this.dpk = this.type;
    }
}
exports.AlertTrigger = AlertTrigger;
